"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const colorprotectionhair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-colorprotectionhair` : '') + (description ? ` desc-colorprotectionhair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-colorprotectionhair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-colorprotectionhair"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_26123_2624)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.94 1.8c3.14.06 5.44 1 7.03 2.56a9.86 9.86 0 0 1 2.66 5.87c.58 4.41-.74 9.6-2.11 13a.75.75 0 0 1-1.4-.56c1.33-3.3 2.56-8.2 2.02-12.25-.27-2-.96-3.75-2.23-5-1.25-1.23-3.15-2.07-6-2.12a.75.75 0 0 1 .03-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.97 9.24c.41.07.7.45.63.86-.63 4.1.53 9.16 1.82 12.58a.75.75 0 0 1-1.4.53c-1.33-3.52-2.59-8.87-1.9-13.34.06-.4.44-.69.85-.63Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.79 6.73a.78.78 0 0 1 .56.37c.05.07.08.15.1.2l.1.3a34.98 34.98 0 0 1 .23.84c.2.65.43 1.33.7 1.75.35.52.62.62.8.67l.22.06c.08.01.19.04.3.08.25.1.52.26.71.6.1.17.13.36.14.46a8.6 8.6 0 0 1-.07 1.5c-.1.82-.34 1.86-.73 2.9a7.64 7.64 0 0 1-2.3 3.31 23.96 23.96 0 0 0 .34 2.47l.06.2v.01a.75.75 0 0 1-1.11 1 1.31 1.31 0 0 1-.27-.43 9.54 9.54 0 0 1-.31-1.35c-.06-.38-.1-.78-.14-1.15a4.6 4.6 0 0 1-2.75-.01c-.03.37-.07.78-.14 1.17-.06.35-.14.72-.27 1.03-.12.28-.33.68-.73.88a.75.75 0 0 1-.73-1.31 3.62 3.62 0 0 0 .26-.85c.1-.59.14-1.25.14-1.7a8.18 8.18 0 0 1-2.28-2.86c-.5-.97-.83-1.98-1-2.87a7.18 7.18 0 0 1-.14-1.24c-.01-.37.02-.74.14-1.06.12-.3.34-.5.55-.63a2 2 0 0 1 .64-.24c.4-.1.9-.14 1.37-.17.48-.04.96-.08 1.41-.15.46-.08.82-.18 1.1-.33a4.32 4.32 0 0 0 1.52-1.75l.26-.49.23-.44c.07-.12.15-.27.25-.4.05-.06.13-.14.23-.21.1-.08.28-.17.5-.17h.1Zm-.33 2.53a5.66 5.66 0 0 1-2.05 2.23 4.9 4.9 0 0 1-1.57.5c-.53.08-1.08.12-1.55.16a8.55 8.55 0 0 0-1.29.18c-.01.09-.03.22-.03.4.01.27.05.6.12.98.15.76.44 1.64.87 2.49.87 1.74 2.18 3.02 3.8 3.02 1.8 0 2.97-1.44 3.69-3.3a11.75 11.75 0 0 0 .72-3.45v-.1h-.02a2.83 2.83 0 0 1-1.92-1.35 7.25 7.25 0 0 1-.77-1.76Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84-.03a2.1 2.1 0 0 1 1.57.2L5.2 1.21a3.8 3.8 0 0 1 3.64.07l3.8 2.2.1.06c.22.16.38.39.45.65l.03.11c.04.27 0 .55-.14.78l-2.63 4.58-.07.1a1.2 1.2 0 0 1-.54.4l-.11.04-.11.03c-.27.04-.55 0-.78-.14L5.03 7.9a3.8 3.8 0 0 1-1.9-3.1L1.36 3.75a2.07 2.07 0 0 1 .49-3.78ZM6.8 7.19l2.5 1.44.27-.47-1-.57a.75.75 0 0 1 .75-1.3l1 .57.27-.48-1-.57a.75.75 0 0 1 .75-1.3l1 .58.27-.48-2.5-1.44-2.3 4.03ZM2.23 1.42a.57.57 0 0 0-.14 1.03l2.18 1.26c.25.14.4.42.37.7a2.3 2.3 0 0 0 .88 2.01l2.3-3.98a2.3 2.3 0 0 0-2.18.25.75.75 0 0 1-.8.04L2.65 1.47a.57.57 0 0 0-.43-.05Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_26123_2624"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = colorprotectionhair;